import Cataclysm from "@/components/Game/Cataclysm.vue";

export const ROLES = {
  GUEST: "GUEST",
  USER: "USER",
  ADMIN: "ADMIN",
};

export const USER_ABILITY_RULES = {
  [ROLES.GUEST]: [],
  [ROLES.USER]: [
    {
      action: "read",
      subject: "User",
      // fields: ["id", "name", "email"],
    },
    {
      action: "update",
      subject: "User",
      // fields: ["name", "email"],
    },
  ],
};

export const CATEGORIES_MOMENT = {
  TEXT: { value: "TEXT", label: "Text" },
  IMAGE: { value: "IMAGE", label: "Image" },
  VIDEO: { value: "VIDEO", label: "Video" },
};

export const CATEGORY_CHAT = {
  CHAT: 0,
  DISCOVERY: 1,
  RAISEHAND: 2,
  RAISEHAND_ACCEPTED: 3,
  SHARE_LINK: 4,
  DELETE_LINK: 5,
  CLEAR_LINK: 6,
  ALERT: 7,
  MUTE_LIVE_CHAT: 8,
  UN_MUTE_LIVE_CHAT: 9,
};

export const INSTRUCTION_TEXTS = {
  login:
    "hello Commander... I am C-Chan from Scarlet Waifu Capital MGMT. You come highly recommended.\n\nYour armies await at your Terminal. May your Reign be long.",
  home: "A-Ah! Senpai… you’re here... I was just preparing your dashboard... 🫣✨\n\nUm, if I may... Do a quick battle of VoidBlitz in your Terminal. Earn ⚡️ to level up. Then I recommend adding just a little AVAX to your PRIVY wallet.\n\nThen you can… um… buy your Sigil.\n Once you do, you’ll start earning AVAX when others trade it—and you’ll also collect NEXUS and MEME Coins through Ranked Battles.\n\nI’ll be right here… supporting you quietly... so please, when you're ready—let’s enter the Hub together and Battle! 💗",
  rank: "Commander! Here you can see who ranks in the VoidBlitz battles as well as Cataclysm. Tap on their profile and see more info about them. You can also claim your Battle Rewards once earned - and tip out to your Sigil Holders.",
  stake:
    "Hello again! If you hold a Vrumbler you can stake that Mystic Rift Walker here and earn $SUJI - which you can then use to later upgrade your Pilots, Mech and Orbs and more!",
  loadout:
    "oh hello Ser! This is your Loadout - the pilot, mech and orb that you have equipped when you enter VoidBlitz and Cataclysm battles from your Terminal - they affect your game play in various ways!",
};

export const ROOM_TITLES = {
  room: {
    title: "👋 Chill ☕️",
    content: "Make a room, chill",
  },
  trivia: {
    title: "BEAT THE BUZZER",
    content: "Head to head Trivia battle with allies in your Nexus Terminal",
  },
  tanks: {
    title: "Tanks : Royale",
    content:
      "Battle in a fast paced, tanks royale showdown! Simple controls, much explosions!",
  },
  crowd_quiz: {
    title: "🤔 Crowd Quiz: BETA 🤔",
    content: "Host a live quiz game for \nthousands to play!",
  },
  bump_wars: {
    title: "🏴‍☠️ BUMP: WARS 🏴‍☠️",
    content:
      "King of the Hill style, get the most bump offs before the timer runs out!",
  },
  bump_royale: {
    title: "⚰️ BUMP: ROYALE ⚰️",
    content: "You die, you lose. Once chance!",
  },
  lap_race: {
    title: "🏁 Lap Race 🏁",
    content: "3 laps and you take the trophy.",
  },
  drag_race: {
    title: "🏎 Drag Race 🏎",
    content: "Straight shot to victory.",
  },
  island_time: {
    title: "🌴 ISLAND TIME 🌴",
    content: "Explore your island with allies.",
  },
  cataclysm: {
    title: "Cataclysm",
    content: "",
  },
  blitz: {
    title: "Blitz",
    content: "",
  },
};

export const UNITY_GAME = {
  DEFAULT_ID: "show",
  UNITY_ZIPPED_ID: "Zipped",
  UNITY_TRIVIA_ID: "Trivia",
  UNITY_TANKS_ID: "Tanks",
  UNITY_BUMPER_WARS_ID: "Bumper_0",
  UNITY_BUMPER_SURVIVAL_ID: "Bumper_1",
  UNITY_BUMPER_DRAG_RACE_ID: "Bumper_2",
  UNITY_BUMPER_LAP_RACE_ID: "Bumper_3",
  UNITY_CRITTARS_ID: "Crittar",
};

export const SITE_NAME = "NEXUS: alpha";
export const SITE_DESCRIPTION = "Space Mech 3D Battle Game and Social Platform";
export const SITE_URL = "https://battle.nexus/";
export const OG_IMAGE = "https://battle.nexus/banner-nexus.png";

export const CHAIN_ID_MAP = {
  avalanche: 43114,
};
